import type { RouteLocationNormalizedLoaded } from "vue-router";
import { ContentType } from "~/types/contentTypes";
import { ModuleStatus } from "~/types/statuses";


export function getDisplayMode(
   route: RouteLocationNormalizedLoaded,
   realSecret: string
 ) {
   if (route.meta?.isDraft) return ModuleStatus.Draft;
   if (route.query.secret !== realSecret) return ModuleStatus.Published;
   return route.query.status === ModuleStatus.Draft
     ? ModuleStatus.Draft
     : ModuleStatus.Published;
 }

 export function getPath({
   contentType,
   category,
   slug,
   secret,
   status,
 }: {
   contentType: string | undefined;
   category: string | undefined;
   slug: string | undefined;
   secret: string | undefined;
   status: string | undefined;
 }) {
   if (!contentType) return "/";
   const previewParams = getPreviewParams(secret, status);

   if (
     [ContentType.BlogPost, ContentType.LandingPage, ContentType.Page].includes(
       contentType as ContentType
     )
   ) {
     return category
       ? `/${category}/${slug}${previewParams}`
       : `/${slug}${previewParams}`;
   }

   if (contentType === ContentType.Case) {
     return `/cases/${slug}${previewParams}`;
   }
   return "/";
 }

function getPreviewParams(
   secret: string | undefined,
   status: string | undefined
 ) {
   return secret && status ? `?secret=${secret}&status=${status}` : "";
 }